/**
 * web-studio-sites D4 — the kit's page events: fired on `document` as
 * `CustomEvent`s for a custom site's own scripts. `pnpm web:contract` publishes
 * them in contract.json's `kit` section and their payloads (the event's
 * `detail`) in contract.d.ts. Names and payload fields only grow.
 */

/** Page event name → when it fires. */
export const KIT_PAGE_EVENTS = {
  'telify:signed-in': 'A visitor signed in on this page.',
  'telify:signed-out': 'The client signed out on this page.',
  'telify:booked': 'A booking was made: fired on the booked page.',
} as const;

/**
 * D4: the pieces made to sit in a header row. Their width changes with the session, so her layout cannot give
 * their placeholder one; the kit draws them in a frame that takes their content's width instead of being a size
 * container. The kit's own list, written on the kit's page (`docs/web-kit/v1.md`), not a published option.
 */
export const KIT_CONTENT_WIDTH_PIECES: readonly string[] = ['account', 'shop-bag-button'];

/** What each page event carries in `detail`. */
export interface TelifyPageEvents {
  /** Carries no detail. */
  readonly 'telify:signed-in': null;
  /** Carries no detail. */
  readonly 'telify:signed-out': null;
  /** The booking just made. */
  readonly 'telify:booked': { readonly bookingId: string };
}
